module.exports = __webpack_public_path__ + "static/media/power-all2.3d928709.png";